import { pushDataLayerEvent } from "../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../shared/utils/encryptUserInfo"

const userInfoEncrypt= encryptUserInfo()
export const buttonClickTransversal = ({ category, label }) => {
  pushDataLayerEvent({
    event: "Interacciones - Mis Puntos",
    category,
    action: "click",
    label,
    Location: window.location.href,
    user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
    log_status: userInfoEncrypt.log_status,
  })
}
